/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinterHoardGameModuleConfig} from "./WinterHoardGameModuleConfig";
import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {GameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/GameModuleConfig";
import {REWinFieldController} from "./keypad/REWinFieldController";
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";


export class WinterHoard extends SlotGame {
    //public VERSION:string = require('../../package.json').version;
    //public name:string = "WinterHoard";
    //private nolimitApp:NolimitApplication;
    // public static keypad: SlotKeypad;
    public static timelineReelsController:TimelineReelsController;
    private static gameRoundManager:GameRoundManager;

    private static NO_WIN_DATA:any = {
        "reels": [
            [
                "L1",
                "M5",
                "L3",
                "L4",
                "L5",
                "M4"
            ],
            [
                "M4",
                "L3",
                "L2",
                "L1",
                "L2",
                "M2"
            ],
            [
                "L3",
                "M4",
                "M5",
                "M2",
                "M3",
                "L2"
            ],
            [
                "L2",
                "M4",
                "M2",
                "M3",
                "M5",
                "S"
            ],
            [
                "M3",
                "M2",
                "M4",
                "M5",
                "L1",
                "L4"
            ]
        ],
        "evaluatedReels": [
            [
                "M5",
                "L3",
                "L4",
                "L5"
            ],
            [
                "L3",
                "L2",
                "L1",
                "L2"
            ],
            [
                "M4",
                "M5",
                "M2",
                "M3"
            ],
            [
                "M4",
                "M2",
                "M3",
                "M5"
            ],
            [
                "M2",
                "M4",
                "M5",
                "L1"
            ]
        ],
        "betLineWins": [],
        "totalSpinWinnings": 0,
        "accumulatedRoundWin": 0,
        "playedBetValue": 1,
        "freespinsPlayed": 0,
        "freespinsLeft": 0,
        "mode": "NORMAL",
        "nextMode": "NORMAL",
        "freespinTriggeredThisSpin": false,
        "reelsNextSpin": "BASE_REELSET",
        "overlayWilds": [
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ]
        ],
        "scatterPositions": [
            -1,
            -1,
            -1,
            -1,
            -1
        ],
        "nearWinReels": [
            false,
            false,
            false,
            false,
            false
        ],
        "reelsEnteringFreespin": [
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ]
        ],
        "mysterySymbolAppearing": false,
        "mysterySymbolRevealed": "",
        "shamanspinTriggered": false,
        "addedNumberOfFreespinsThisSpin": 0,
        "energyCollectedBefore": 0,
        "energyCollectedAfter": 0,
        "symbolsToM1": [],
        "symbolMultipliers": {},
        "overlayM1": [
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ],
            [
                false,
                false,
                false,
                false
            ]
        ],
        "scattersInTrigger": 0,
        "playerFSSelection": -1,
        "fsChoicesActive": [],
        "featureBuyTimesBetValue": [
            {
                "name": "FREESPIN",
                "type": "FREESPIN",
                "price": 100
            },
            {
                "name": "SUPER_FREESPIN",
                "type": "FREESPIN",
                "price": 600
            }
        ],
        "wasFeatureBuy": false,
        "numberFreespins": [
            0,
            0
        ],
        "nearWinBigWinReels": [
            false,
            false,
            false,
            false,
            false
        ]
    }


    getNoWinGameData():any {
        return WinterHoard.NO_WIN_DATA;
    }

    constructor() {
        super(WinterHoardGameModuleConfig.instance);
    }

    protected initGame():void {
        if (GameModuleConfig.instance.GAME_ROUND_CONFIG) {
            Reels.init();
            WinterHoard.timelineReelsController = TimelineReelsController.instance;
            WinterHoard.gameRoundManager = new GameRoundManager(GameModuleConfig.instance.GAME_ROUND_CONFIG());
        }
        else {
            super.initGame();
        }
    }

    protected createWinFieldController():WinFieldController {
        return new REWinFieldController();
    }

    /*protected onInitResourcesLoaded(event:LoaderEvent):void {
        if(event.key == ResourcesGroupName.MAIN) {
            this.prepareGraphics();
        }
        super.onInitResourcesLoaded(event);
    }

    private prepareGraphics() {
        const bgTexture = GameResources.getTextures(WinterHoardGameAssets.MAIN_GAME_BACKGROUND)[0];
        WinterHoard.applyColorEffect(bgTexture, WinterHoardGameAssets.FREE_SPIN_BACKGROUND);

    }


    private static applyColorEffect(sourceTexture:PIXI.Texture, newId:string) {
        const sprite = new PIXI.Sprite(sourceTexture);
        const colorMatrixFilter = new PIXI.filters.ColorMatrixFilter();
        colorMatrixFilter.negative(false);
        sprite.filters = [colorMatrixFilter];
        const renderTexture:PIXI.RenderTexture = PIXI.RenderTexture.create({
            width : sourceTexture.width,
            height : sourceTexture.height,
            scaleMode : sourceTexture.baseTexture.scaleMode,
            resolution : sourceTexture.baseTexture.resolution
        });
        StageManager.renderer.render(sprite, renderTexture);

        const id:string = newId;
        if(PIXI.utils.TextureCache[id]) {
            PIXI.utils.TextureCache[id] = renderTexture;
        }
        else {
            PIXI.Texture.addToCache(renderTexture, id);
        }

    }*/


}